module.exports = __webpack_public_path__ + "img/DAB_MAXIM.9e69bf9f.png";